<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Avatar Square" pageTitle="Avatar Square" />
            <AvatarSquare />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import AvatarSquare from '../AvatarSquare/AvatarSquare'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'AvatarSquarePage',
    components: {
        MainHeader,
        PageTitle,
        AvatarSquare,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>